module.exports = __webpack_public_path__ + "static/img/icon-4.2e54bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/icon-4.png
// module id = dOv1
// module chunks = 0